import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faStar from '@fortawesome/fontawesome-free-solid/faStar';
import * as faStarHollow from '@fortawesome/fontawesome-free-regular/faStar';
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt';

import 'react-image-gallery/styles/css/image-gallery.css';
import itemDefault from '../../../../images/item-default.png';
import AttachmentUploader from '../../../common/AttachmentUploader';
import Button from '../../../common/Button';
import formPropsType from '../../../common/types/formPropsType';
import './Gallery.css';
import AttachmentImage from './AttachmentImage';

class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Known ESLint issue, see https://github.com/yannickcr/eslint-plugin-react/issues/1697
      // eslint-disable-next-line react/no-unused-state
      itemsLength: props.images.length,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const newItemsCount = this.props.images.length;

    if (this.imageGallery != null && prevState.itemsLength !== newItemsCount) {
      // Must have uploaded new images. Scroll to the last image in the set and update state
      this.imageGallery.slideToIndex(newItemsCount - 1);
      // eslint-disable-next-line react/no-unused-state
      this.setState({ itemsLength: newItemsCount });
    }
  }

  renderMainImageControl = () => {
    // determine if the current image is a main one
    if (!this.imageGallery) return null;

    const {
      images, onChangeMainAttachment, onDeleteImage, formProps,
    } = this.props;

    const currIndex = this.imageGallery.getCurrentIndex();
    const isMain = images[currIndex].isMainAttachment;

    const clickHandler = () => {
      if (!isMain) {
        onChangeMainAttachment(images[currIndex]);
        this.imageGallery.slideToIndex(0);
      }
    };

    const deleteClickHandler = () => {
      onDeleteImage(images[currIndex]);
      this.imageGallery.slideToIndex(0);
    };

    return (
      <div>
        <div className="imageGallery-mainAttToggle">
          <button
            className="functionOnlyButton"
            type="button"
            onClick={clickHandler}
            title="Set this image as the featured image"
          >
            <FontAwesomeIcon icon={isMain ? faStar : faStarHollow} size="2x" />
          </button>

        </div>
        <div className="imageGallery-deleteButton">
          <Button
            type="button"
            color="danger"
            title="Delete this image"
            handler={deleteClickHandler}
            isDisabled={formProps && formProps.isSubmitting}
            label={
              <FontAwesomeIcon icon={faTrashAlt} className="icon" fixedWidth />}
          />
        </div>
      </div>
    );
  };

  renderThumbnail = (item) => {
    // Primarily a copy from ImageGallery's default _renderThumbInner, but with AttachmentImage
    return (
      <div className="image-gallery-thumbnail-inner" key={item.id}>
        <AttachmentImage imgSrc={item.thumbnail} alt={item.thumbnailAlt} />
        {item.thumbnailLabel && (
          <div className="image-gallery-thumbnail-label">{item.thumbnailLabel}</div>
        )}
      </div>
    );
  };

  render() {
    const items = this.props.images.map(image => ({
      id: image.id,
      original: image.path,
      thumbnail: image.thumbnailPath,
      originalAlt: image.originalFileName,
      thumbnailAlt: image.originalFileName,
    }));

    return (
      <React.Fragment>
        {items.length > 0 ? (
          <ImageGallery
            items={items}
            infinite={false}
            ref={(i) => {
              this.imageGallery = i;
            }}
            showFullscreenButton={false}
            showPlayButton={false}
            defaultImage={itemDefault}
            renderCustomControls={this.renderMainImageControl}
            renderThumbInner={this.renderThumbnail}
          />
        ) : (
          // eslint-disable-next-line jsx-a11y/img-redundant-alt
          <img src={itemDefault} alt="No item image yet" />
        )}
        {this.props.allowUploads && (
          <div className="galleryUpload">
            <AttachmentUploader
              attType="IMAGE"
              buttonLabel="Add a Photo"
              buttonColor="white"
              buttonClassName="has-text-grey"
              onSuccess={this.props.onUploadNewAttachment}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    originalFileName: PropTypes.string.isRequired,
    isMainAttachment: PropTypes.bool.isRequired,
    isStock: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
    thumbnailPath: PropTypes.string.isRequired,
  })),
  formProps: formPropsType,
  allowUploads: PropTypes.bool,
  onChangeMainAttachment: PropTypes.func.isRequired,
  onDeleteImage: PropTypes.func.isRequired,
  onUploadNewAttachment: PropTypes.func.isRequired,
};

Gallery.defaultProps = {
  images: [],
  allowUploads: true,
  formProps: null,
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Gallery.jsx